import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';

import Button from '@/components/Button';
import { DialogTop } from '@/components/Dialog';
import Label from '@/components/form/Label';
import Copy from '@/icons/copy.svg';
import routes from '@/routes';
import { showSuccess } from '@/utils';

function ShareCopyLink({ onOpenChange, id }) {
	const { t } = useTranslation();
	const url = `${window.location.origin}${generatePath(routes.sharedDocument, { id })}`;

	const copyUrl = e => {
		e.preventDefault();
		navigator.clipboard.writeText(url);
		onOpenChange();
		showSuccess(t('myDocuments.toast.shareDocumentSuccess'));
	};

	return (
		<>
			<DialogTop
				title={t('myDocuments.modals.share.title')}
				description={t('myDocuments.modals.share.description')}
			/>

			<div className="flex flex-col px-4 py-9">
				<Label htmlFor="share-document-modal-input">
					{t('myDocuments.modals.share.label')}
				</Label>

				<div className="flex w-full gap-2 rounded border border-gray-200 px-3 py-1 text-sm transition-colors placeholder:text-gray-500 focus:border-black focus-visible:outline-none">
					<input
						id="share-document-modal-input"
						name="link"
						value={url}
						type="text"
						readOnly
						className="w-full flex-shrink focus:outline-none"
					/>
					<Button
						disabledtype="button"
						size="icon"
						variant="outline"
						className="border-0 p-0"
						onClick={copyUrl}
					>
						<Copy size={17} />
					</Button>
				</div>
			</div>
		</>
	);
}

export default ShareCopyLink;
